import React from "react";
import Select from "react-select";
import { connect } from "react-redux";

import { debounce } from "throttle-debounce";
import qs from "qs";
import moment from "moment";
import Request from "request";
import {Event} from "components/Comet";
import toast, { Toaster } from "react-hot-toast";
import { Table, DropdownButton, FormControl, Button, Glyphicon, ControlLabel, ButtonGroup, MenuItem } from "react-bootstrap";
import { clientAccessPreModerationGet, clientBalanceHistory, clientChangeRole, clientEventRegistrationDelete, clientEventRegistrationsDeleteAll, clientEventRegistrationsGroupDelete, clientFieldChange } from "../../../../api/cp";
import { getEventRegistrationFields, mapValueToSelectOption, translateLabel } from "./tools";
import {
    eventRegistrationRoleOptions,
    eventRegistrationStatusOptions,
    konturFocusFields,
    participationTypes,
    checkboxFieldOptions,
    photoValidField,
} from "./models";
import { TYPE_KONTUR_FOCUS, TYPE_PHOTO, AVAILABLE_TYPES } from "./constants";
import { ModuleSettingsContext } from "../../../context";
import locale from "../../../locale";

import Loading from "components/Loading";
import PaginationBar from "components/PaginationBar";
import DatetimeRangePicker from "../../DatetimeRangePicker";
import { ClientImportTimePadModal } from "../ClientImportTimePad";
import { ClientEditModal } from "./ClientModals/ClientEdit";
import ClientImportExcelModal from "../ClientImportExcel";
import ClientBalanceHistoryModal from "../Statistic/ClientBalanceHistoryModal";
import DeleteConfirmOverlay from "../../UI/DeleteConfirmOverlay";

import "./style";

const TableEventRegistrationFieldValue = ({ field, eventRegistration }) => {
    const value = eventRegistration.info[field.name];

    if (['checkbox', 'disclaimer'].includes(field.type)) {
        return <>{value ? 'Да' : 'Нет'}</>;
    }

    if ('photo' === field.type) {
        return (
            <img
                src={eventRegistration.info.photo}
                alt=""
                style={{ width: 'auto', height: '60px' }}
            />
        );
    }

    return <>{value}</>
}

class EventAccessPreModeration extends React.Component {
    state = {
        isLoading: true,
        entries: [],
        ids: {},
        pagination: null,
        currentClient: null,
        additionalFields: [],
        importTimePadVisible: false,
        isImportExcelModalVisible: false,
        sheets: null,
        filter: null,
        clientBalanceHistory: null,
        participationTypesOptions: null,

        isBlacklistActive: false,
        blacklist: false,
    };

    constructor(props, context) {
        super(props, context);

        this.changeFilter = this.changeFilter.bind(this);
        this.handleFilterFieldChanged = this.handleFilterFieldChanged.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.onGroupChangeField = this.onGroupChangeField.bind(this);
        this.changeField = this.changeField.bind(this);
        this.onFilterFieldChange = debounce(2000, this.onFilterFieldChange.bind(this));
        this.onFilterOptionChange = debounce(800, this.onFilterOptionChange.bind(this));
        this.onFilterDateChange = this.onFilterDateChange.bind(this);
        this.handleAllEntriesToggle = this.handleAllEntriesToggle.bind(this);
        this.handleImportExcel = this.handleImportExcel.bind(this);
        this.participationTypesOptions = AVAILABLE_TYPES.map((field) => mapValueToSelectOption(field, 'participationType'));

        this.handleBlacklistFilterChanged = this.handleBlacklistFilterChanged.bind(this);
        this.getDataType = this.getDataType.bind(this);
    }

    componentDidMount() {
        const queryData = qs.parse(this.props.location.search.substring(1));

        if (queryData?.filter?.hasOwnProperty('roles')) {
            queryData.filter.roles = eventRegistrationRoleOptions.filter(({ value }) => queryData.filter.roles.includes(value));
        }

        if (queryData?.filter?.hasOwnProperty('participationTypes')) {
            queryData.filter.participationTypes = this.participationTypesOptions.filter(({ value }) => queryData.filter.participationTypes.includes(value));
        }

        if (queryData.hasOwnProperty('filter')) {
            this.setState({
                filter: {
                    ...this.state.filter,
                    ...queryData.filter,
                }
            });
        }

        this.fetch();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location.search !== this.props.location.search) {
            this.fetch();
        }

        if (this.state.sheets && prevState.sheets !== this.state.sheets) {
            this.setState({ isImportExcelModalVisible: true });
        }
    }

    handleAllEntriesToggle(e) {
        let ids = {};
        if (e.target.checked) {
            this.state.entries.map(entry => {
                ids[entry.id] = entry.id;
            });
        }

        this.setState({ ids });
    }

    fetch() {
        const queryData = qs.parse(this.props.location.search.substring(1));
        const filter = queryData.hasOwnProperty('filter') ? queryData.filter : {};
        const page = queryData.hasOwnProperty('page') ? queryData.page : 1;
        const blacklist = queryData.hasOwnProperty('blacklist') ? queryData.blacklist : null;

        const { event } = this.props;

        this.setState({ isLoading: true, entries: [] });

        const query = {};
        if (!!page) {
            query.page = page;
        }

        if (!!filter && Object.keys(filter).length > 0) {
            query.filter = filter;
        }

        if (!!blacklist) {
            query.blacklist = blacklist;
        }

        clientAccessPreModerationGet(event.eventPassword, query)
            .then(data => this.setState({ ids: {}, entries: data.data, pagination: data.pagination, additionalFields: data.additionalFields, isBlacklistActive: data.filters.includes('blacklist') }))
            .catch(() => { })
            .then(() => this.setState({ isLoading: false }))
            ;
    }

    changeFilter(field, value) {
        const search = { filter: {} };
        search['filter'][field] = value;
        this.props.history.push({
            search: qs.stringify(search, { encodeValuesOnly: true }),
        });
    }

    onFilterFieldChange(e, name) {
        this.setState((prevState) => {
            return {
                filter: {
                    ...prevState.filter,
                    [name]: e.target.value,
                }
            }
        })

        console.log('name :>> ', name);

        this.handleFilterFieldChanged(name, e.target.value);
    }

    onFilterOptionChange(selectedOptions, name) {
        const options = selectedOptions.map(selected => selected.value);

        this.setState({
            filter: {
                ...this.state.filter,
                [name]: selectedOptions,
            }
        })

        console.log('this.state.filter :>> ', this.state.filter);

        this.handleFilterFieldChanged(name, options);
    }

    onCheckboxSelectChange = (value, field) => {
        this.setState(prev => ({ ...prev, filter: { ...prev.filter, [field]: value } }));
        this.handleFilterFieldChanged(field, value);
    }

    onFilterDateChange(e, picker) {
        const startDate = (picker.startDate).format('YYYY-MM-DD HH:mm:ss');
        const endDate = (picker.endDate).format('YYYY-MM-DD HH:mm:ss');

        this.handleFilterFieldChanged('createdAt', {
            min: startDate,
            max: endDate,
        });
    }

    onEntryIdSelected(entry) {
        return (e) => {
            let ids = { ...this.state.ids };

            if (e.target.checked) {
                ids[entry.id] = entry.id;
            } else {
                delete (ids[entry.id]);
            }

            this.setState({ ids });
        };
    }

    handleFilterFieldChanged(field, value) {
        const oldQueryString = this.props.history.location.search.substring(1);

        const queryData = qs.parse(oldQueryString);
        delete queryData.page;
        if (!queryData.hasOwnProperty('filter')) {
            queryData.filter = {};
        }

        if (0 === value.length) {
            delete queryData.filter[field];
        } else {
            queryData.filter[field] = value;
        }

        const newQueryString = qs.stringify(queryData, { encodeValuesOnly: true });
        if (oldQueryString !== newQueryString) {
            this.props.history.push({
                search: newQueryString,
            });
        }
    }

    handleResetFilters() {
        this.setState({ filter: null });
        this.props.history.push({
            search: null,
        });
    }

    handlePageChanged(page) {
        const queryData = qs.parse(this.props.location.search.substring(1));
        queryData.page = page;
        this.props.history.push({
            search: qs.stringify(queryData, { encodeValuesOnly: true }),
        });
    }

    onGroupChangeField({fieldName, value}) {
        const { ids } = this.state;

        this.changeField({fieldName, value, ids})
            .then(() => {
                this.fetch();
                this.setState({ ids: {} });
            });
    }

    onGroupDeleteReg () {
        const { event } = this.props;
        const { ids } = this.state;
        clientEventRegistrationsGroupDelete(event.eventKey, {clientRegistrationIds: Object.values(ids)});
    }

    changeField({fieldName, value, ids}) {
        const { event } = this.props;

        const isFieldChanged = clientFieldChange(event.eventKey, { fieldName, value, ids });

        const toastPromises = Object.keys(ids).map(() => {
            return toast.promise(
                isFieldChanged,
                {
                    success: locale(`${fieldName}.change.success`, { value: translateLabel(fieldName, value) }),
                    error: locale('field.change.error'),
                },
                {
                    success: {
                        duration: 4000,
                    },
                },
            );
        });

        return Promise.all(toastPromises);
    }

    onChangeClient(eventRegistration) {
        const eventRegistrations = this.state.entries.slice();
        const index = eventRegistrations.findIndex(({ id }) => id === eventRegistration.id);
        if (-1 !== index) {
            eventRegistrations[index] = eventRegistration;
        } else {
            eventRegistrations.push(eventRegistration);
        }
        this.setState({ entries: eventRegistrations });
    }

    handleImportExcel() {
        const fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        fileInput.addEventListener('change', (e) => {
            const file = e.target.files[0];
            if (!file) {
                console.log('File not select');
                return;
            }

            this.setState({ isLoading: true });
            Request.post(`/api/cp/excel/parseFile`, { file })
                .then((sheets) => this.setState({ sheets: sheets }))
                .catch((error) => {
                    alert(error);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.setState({ isLoading: false });
                    }, 100);
                });

        }, false);
        fileInput.click();
    }

    // TODO возможно потом нежно выпилить
    handleBlacklistFilterChanged(isShow) {
        this.setState({ blacklist: isShow });
        const queryData = qs.parse(this.props.location.search.substring(1));
        queryData.blacklist = isShow;
        this.props.history.push({
            search: qs.stringify(queryData, { encodeValuesOnly: true }),
        });
    }

    handleDeleteReg = (entry) => {
        const { event } = this.props;
        clientEventRegistrationDelete(event.eventKey, entry.id);
    }

    handleDeleteAllRegs = () => {
        const { event } = this.props;
        clientEventRegistrationsDeleteAll(event.eventKey)
    }

    getDataType = (type) => {
        let _type = type;
        if (type === 'disclaimer') {
            _type = 'checkbox'
        }

        return _type;
    }

    render() {
        const { isLoading, entries } = this.state;
        const { event } = this.props;

        if (isLoading) {
            return <Loading>Загрузка списка зрителей</Loading>;
        }

        const fields = getEventRegistrationFields(event);

        const { timeStart } = event;
        const { timeStop } = event;

        let entriesFiltered = [...entries];
        let updatedFields = [...fields];

        entriesFiltered.forEach((entry) => {
            if (entry.info.konturFocusOrg) {
                const { organizationName, organizationInn, organizationKpp } = entry.info.konturFocusOrg;

                entry.info['organizationName'] = organizationName;
                entry.info['organizationInn'] = organizationInn;
                entry.info['organizationKpp'] = organizationKpp;

                delete entry.info.konturFocusOrg;
            }

            if (entry.info.photo) {
                const { photoValid } = entry.info;

                entry.info.photoValid = photoValid;
            }
        })

        const indexKontur = updatedFields.findIndex((field) => field.type === TYPE_KONTUR_FOCUS);
        if (indexKontur >= 0) {
            updatedFields.splice(indexKontur, 1, ...konturFocusFields)
        }

        const indexPhoto = updatedFields.findIndex((field) => field.type === TYPE_PHOTO);
        if (indexPhoto >= 0) {
            updatedFields.splice(indexPhoto + 1, 0, photoValidField)
        }

        const EntryRow = ({ entry }) => {
            return (
                <ModuleSettingsContext.Consumer>
                    {({ moduleActivity }) => (
                        <tr style={{
                            backgroundColor: !!entry.info.blacklist ? 'rgb(255 178 178)' : '',
                        }}>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={this.state.ids.hasOwnProperty(entry.id)}
                                    onChange={this.onEntryIdSelected(entry)}
                                />
                            </td>
                            <td>{entry.client.email}</td>
                            {updatedFields.map((field) => (
                                <td key={field.name}>
                                    <TableEventRegistrationFieldValue
                                        field={field}
                                        eventRegistration={entry}
                                    />
                                </td>
                            ))}
                            <td>{participationTypes[entry.participationType]}</td>
                            <td>{moment.unix(entry.createdAt).format('YYYY-MM-DD HH:mm:ss')}</td>
                            <td>
                                <Select
                                    isClearable={false}
                                    isSearchable={false}
                                    options={eventRegistrationRoleOptions}
                                    defaultValue={mapValueToSelectOption(entry.role)}
                                    onChange={(option) => this.changeField({ fieldName: 'role', value: option.value, ids: [entry.id] })}
                                />
                            </td>
                            <td>
                                <Select
                                    isClearable={false}
                                    isSearchable={false}
                                    options={eventRegistrationStatusOptions}
                                    defaultValue={mapValueToSelectOption(entry.status, 'status')}
                                    onChange={(option) => this.changeField({ fieldName: 'status', value: option.value, ids: [entry.id] })}
                                />
                            </td>
                            {moduleActivity.enabled && (
                                <>
                                    <td>
                                        {entry.balanceIncreaseTotal}
                                    </td>
                                    <td>
                                        {entry.balance}
                                    </td>
                                    <td>
                                        <Button onClick={() => this.setState({ clientBalanceHistory: entry })}>
                                            <Glyphicon glyph="signal" />
                                        </Button>
                                    </td>
                                </>
                            )}
                            <td>
                                <ButtonGroup style={{ display: 'flex' }}>
                                    <Button onClick={() => this.setState({ currentClient: entry })}>
                                        <Glyphicon glyph="pencil" />
                                    </Button>
                                    <DeleteConfirmOverlay title="Точно удалить регистрацию?" buttonText="Удалить" onConfirm={() => this.handleDeleteReg(entry)}>
                                        <Button bsSize="small" bsStyle="danger"><Glyphicon glyph="trash" /></Button>
                                    </DeleteConfirmOverlay>
                                </ButtonGroup>
                            </td>
                        </tr>
                    )}
                </ModuleSettingsContext.Consumer>
            );
        };

        return (
            <ModuleSettingsContext.Consumer>
                {({ moduleActivity }) => (
                    <section className="Entries">
                        <p>
                            <Button bsStyle="primary" onClick={() => this.setState({ currentClient: {} })}>Добавить участника</Button>
                            {' '}
                            <Button onClick={() => this.setState({ importTimePadVisible: true })}>Импорт из TimePad</Button>
                            {' '}
                            <Button onClick={this.handleImportExcel.bind(this)}>Импорт из Excel</Button>
                            {' '}
                            <Button>
                                <a href={`/api/cp/excel/upload_registered_users/${event.eventKey}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                    Скачать список
                                </a>
                            </Button>
                            {' '}
                            <DeleteConfirmOverlay
                                title="Вы подтверждаете удаление всех регистраций?" 
                                buttonText="Удалить все регистрации" 
                                onConfirm={() => this.handleDeleteAllRegs()}
                             >
                                <Button bsSize="small" bsStyle="danger">Удалить все регистрации</Button>
                            </DeleteConfirmOverlay>
                        </p>

                        <ClientEditModal
                            fields={updatedFields}
                            entries={this.state.entries}
                            getDataType={this.getDataType}
                            eventRegistration={this.state.currentClient}
                            event={event}
                            onClose={() => this.setState({ currentClient: null })}
                            onChange={this.onChangeClient.bind(this)}
                        />

                        <ClientBalanceHistoryModal
                            event={event}
                            updateClient={this.onChangeClient.bind(this)}
                            client={this.state.clientBalanceHistory && { ...this.state.clientBalanceHistory, reg_id: this.state.clientBalanceHistory.id }}
                            onHide={() => this.setState({ clientBalanceHistory: null })}
                        />

                        <ClientImportTimePadModal
                            visible={this.state.importTimePadVisible}
                            onClose={() => this.setState({ importTimePadVisible: false })}
                        />

                        <ClientImportExcelModal
                            isModalVisible={this.state.isImportExcelModalVisible}
                            sheets={this.state.sheets}
                            registrationFields={this.state.additionalFields}
                            event={event}
                            roles={eventRegistrationRoleOptions}
                            participationTypes={this.participationTypesOptions}
                            onDone={() => {
                                this.fetch();
                                this.setState({ isImportExcelModalVisible: false, sheets: null });
                            }}
                            onClose={() => { this.setState({ isImportExcelModalVisible: false, sheets: null }) }}
                        />

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <ControlLabel>Зарегистрировалось всего: {this.state.pagination?.totalCount ?? 1}</ControlLabel>
                            {
                                this.state.isBlacklistActive &&
                                <label htmlFor="blacklist">
                                    <input
                                        id='blacklist'
                                        type="checkbox"
                                        checked={this.state.blacklist}
                                        onChange={(e) => this.handleBlacklistFilterChanged(e.target.checked)}
                                    />
                                    &nbsp;
                                    <span>
                                        Показать пользователей из черного списка
                                    </span>
                                </label>
                            }
                        </div>

                        {
                            !!this.state.filter &&
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button bsStyle="primary" bsSize="xsmall" onClick={() => this.handleResetFilters()}>Сбросить фильр</Button>
                            </div>
                        }

                        <Table
                            responsive
                            className="entries-table"
                        >
                            <thead>
                                <tr>
                                    <th width="20">{' '}</th>
                                    <th width="250">Электронная почта</th>
                                    {updatedFields.map(({ name, label }) => (
                                        <th key={name} width="200">
                                            <span className="table-header-field">
                                                {label}
                                            </span>
                                        </th>
                                    ))}
                                    <th width="220">Формат участия</th>
                                    <th width="150">Дата регистрации</th>
                                    <th width="220">Роль</th>
                                    <th width="220">Статус</th>
                                    {moduleActivity.enabled && (
                                        <>
                                            <th width="100">Заработанные баллы</th>
                                            <th width="100">Оставшиеся баллы</th>
                                            <th width="20" />
                                        </>
                                    )}
                                    <th width="30" />
                                </tr>
                                <tr className="filter">
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={this.state.entries.length > 0 && this.state.entries.length === Object.keys(this.state.ids).length}
                                            onChange={this.handleAllEntriesToggle}
                                        />
                                    </td>
                                    <td>
                                        <FormControl
                                            type="text"
                                            defaultValue={this.state.filter?.email ?? ''}
                                            onChange={e => this.onFilterFieldChange(e, 'email')}
                                        />
                                    </td>
                                    {updatedFields.map((field) => (
                                        <td key={`table-header_${field.name}`}>
                                            {['checkbox', 'disclaimer'].includes(field.type) ? <Select
                                                name="checkboxSelect"
                                                options={checkboxFieldOptions}
                                                value={checkboxFieldOptions.find(option => option.value === this.state.filter?.[field.name]) || checkboxFieldOptions[0]}
                                                onChange={(option) => this.onCheckboxSelectChange(option.value, field.name)}
                                            /> :
                                                <FormControl
                                                    type="text"
                                                    defaultValue={this.state.filter?.[field.name] ?? ''}
                                                    onChange={e => this.onFilterFieldChange(e, field.name)}
                                                />
                                            }
                                        </td>
                                    ))}
                                    <td>
                                        <Select
                                            placeholder="Выберите значение"
                                            closeMenuOnSelect={false}
                                            isMulti
                                            name="participationTypes"
                                            options={this.participationTypesOptions}
                                            value={this.state.filter?.participationTypes ?? []}
                                            onChange={(type) => this.onFilterOptionChange(type, 'participationTypes')}
                                        />
                                    </td>
                                    <td>
                                        <DatetimeRangePicker
                                            startDate={moment.unix(timeStart)}
                                            endDate={moment.unix(timeStop)}
                                            timePicker
                                            timePicker24Hour
                                            imePickerSeconds
                                            onApply={this.onFilterDateChange}
                                            applyClass="btn-primary"
                                            cancelClass="btn-link"
                                        >
                                            <FormControl
                                                size="40"
                                                type="text"
                                                name="timeStart"
                                                value={`${moment.unix(timeStart).format('YYYY-MM-DD HH:mm:ss')} - ${moment.unix(timeStop).format('YYYY-MM-DD HH:mm:ss')}`}
                                                onChange={this.onFilterDateChange}
                                            />
                                        </DatetimeRangePicker>
                                    </td>
                                    <td>
                                        <Select
                                            placeholder="Выберите значение"
                                            closeMenuOnSelect={false}
                                            isMulti
                                            name="roles"
                                            options={eventRegistrationRoleOptions}
                                            value={this.state.filter?.roles ?? []}
                                            onChange={(role) => this.onFilterOptionChange(role, 'roles')}
                                        />
                                    </td>
                                    <td>
                                        <Select
                                            placeholder="Выберите значение"
                                            closeMenuOnSelect={false}
                                            isMulti
                                            name="statuses"
                                            options={eventRegistrationStatusOptions}
                                            value={this.state.filter?.statuses ?? []}
                                            onChange={(status) => this.onFilterOptionChange(status, 'statuses')}
                                        />
                                    </td>
                                    {moduleActivity.enabled && (
                                        <td />
                                    )}
                                    <td />
                                </tr>
                            </thead>
                            <tbody>
                                {entriesFiltered.map((entry) => <EntryRow entry={entry} key={entry.id} />)}
                            </tbody>
                        </Table>
                        <div className="group-actions-wrapper" style={{ bottom: 0 === Object.keys(this.state.ids).length ? '-100%' : '0' }}>
                            <DropdownButton
                                title="Действия"
                                id="bt-group-actions"
                            >
                                <li role="presentation" className="">
                                    <a role="menuitem" tabIndex="-1" href="#">
                                        Изменить роль <span className="caret" />
                                    </a>
                                    <ul className="dropdown-menu sub-menu" aria-labelledby="bt-group-actions">
                                        {eventRegistrationRoleOptions.map(({value, label}) =>
                                            <li key={value}>
                                                <a
                                                    role="menuitem"
                                                    tabIndex="-1"
                                                    onClick={() => this.onGroupChangeField({fieldName: 'role', value})}
                                                >
                                                    {label}
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                                <li role="presentation" className="">
                                    <a role="menuitem" tabIndex="-1" href="#">
                                        Изменить статус <span className="caret" />
                                    </a>
                                    <ul className="dropdown-menu sub-menu" aria-labelledby="bt-group-actions">
                                        {eventRegistrationStatusOptions.map(({value, label}) =>
                                            <li key={value}>
                                                <a
                                                    role="menuitem"
                                                    tabIndex="-1"
                                                    onClick={() => this.onGroupChangeField({fieldName: 'status', value})}
                                                >
                                                    {label}
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                                <MenuItem onClick={() => this.onGroupDeleteReg()}>Удалить</MenuItem>
                            </DropdownButton>
                        </div>
                        <PaginationBar
                            activePage={+this.state.pagination?.page ?? 1}
                            pageCount={+this.state.pagination?.pageCount ?? 1}
                            onSelect={page => this.handlePageChanged(page)}
                        />

                        <Toaster
                            position="top-right"
                            toastOptions={{
                                style: {},
                            }}
                        />
                        <Event event="task:delete/clientRegistrations" handler={() => this.fetch()} />
                    </section>
                )}
            </ModuleSettingsContext.Consumer>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent
    };
};

export default connect(mapStateToProps)(EventAccessPreModeration);
